<template>
  <div class="none_404">
    <img src="https://www.bioflin.com:83/image/none/404.png" alt />
    <div class="text">很抱歉 ，您访问的页面不存在</div>
    <div class="btn">
      <router-link :to="path">
        <div class="div1">返回上一级</div>
      </router-link>
      <router-link to="/">
        <div class="div2">返回首页</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: ""
    };
  },
  activated() {
    this.path = this.$cookies.get("returnPath");
  }
};
</script>

<style lang='scss'>
.none_404 {
  width: 1200px;
  margin: 0 auto;
  .text {
    font-size: 24px;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
  .btn {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    width: 555px;
    padding: 63px 0 154px 0;
    div {
      width: 185px;
      height: 50px;
      border-radius: 25px;
      font-size: 20px;
      font-family: "Source Han Sans CN";
      font-weight: 500;
      color: rgba(40, 40, 40, 1);
      line-height: 50px;
      text-align: center;
      cursor: pointer;
    }
    .div1 {
      box-shadow: 0 4px 0px #f69d20;
      background: #ffd050;
    }
    .div2 {
      box-shadow: 0 4px 0px #009bd6;
      background: #88d4f1;
    }
  }
}
</style>